
import { Component, Vue, Mixins, Prop, Watch } from "vue-property-decorator";
import { namespace, Mutation, Getter } from "vuex-class";

import api from "@/services/api.service";
import "@/scripts/string-operations";

import vSelect from "vue-select";
import ReportFilters from "./ReportFilters.vue";

const Reports = namespace("reports");

@Component({
	components: {
		"v-select": vSelect,
		"report-filters": ReportFilters
	}
})
export default class TemplateReportBuilder extends Vue {

	@Reports.Getter("getReport") report;
	@Reports.Getter("getReportApiEndpoint") reportApiEndpoint: string;

	@Reports.Action getReportUrl;

	public selectedTemplate: any = null;
	TimeZone: string = "UTC";

	@Prop()
	public value: any;

	async mounted() {
		this.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	}

	get template () {
		if (!this.report || !this.report.templates) {
			return null;
		}

		if (this.report.templates.length == 1)
			return this.report.templates[0];
		else
			return this.selectedTemplate;
	}

	public async reportUrl (): Promise<string> {
		const selectedFilters = this.value;
		return this.reportApiEndpoint.trimEndOf(["/"]) + "/" +
			"Reports/DownloadReportPDF" +
			await this.getReportUrl({
				templateId: this.template.reportTemplateID,
				selectedFilters
			}) + "&timeZone=" + this.TimeZone;
	}

	async generateReport() {
		if (!this.template)
			return;

		let link = document.createElement("a");
		link.href = link.download = await this.reportUrl();

		link.click();
	}
}
